// domain/capacitacion.schema.js  (yup es agnóstico de React; se permite en domain)
import * as yup from 'yup';

export const MAX_NOMBRE_CAPACITACION = 100;

// '' / undefined -> null; el resto se castea a número
const optionalId = yup
  .number()
  .transform((value, original) => (original === '' || original === null || original === undefined ? null : value))
  .nullable();

export const capacitacionSchema = yup.object().shape({
  nombre_capacitacion: yup
    .string()
    .trim()
    .required('El nombre es requerido')
    .max(MAX_NOMBRE_CAPACITACION, `Máximo ${MAX_NOMBRE_CAPACITACION} caracteres`),
  responsable: yup
    .string()
    .trim()
    .required('El responsable es requerido')
    .max(255, 'Máximo 255 caracteres'),
  fecha: yup
    .string()
    .required('La fecha es requerida')
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida'),
  id_actividades: yup
    .array()
    .transform((value, original) => (original === null || original === undefined ? [] : value))
    .of(yup.number())
    .min(1, 'Selecciona al menos una actividad')
    .required('Selecciona al menos una actividad'),
  id_municipio: optionalId,
  id_localidad: optionalId,
  id_ciclo: optionalId,
  descripcion: yup.string().nullable(),
  // Opcional: vacío o null es válido.
  materiales: yup
    .string()
    .trim()
    .nullable(),
});
